import React from 'react';
import Modal from '../../components/Modal/Modal';
import Button from "../Button";
import { Typography, Box } from '@material-ui/core';
import {setModalReset} from "../../actions/app";
import {connect} from "react-redux";

const PaymentMethodErrorModal = ({setModalReset, errorMessage = ''}) => {
    const handleClose = () => {
        setModalReset();
    }
    return (
        <Modal
            id="payment-method-error-modal"
            maxWidth="sm"
            title="We are sorry"
            onClose={handleClose}
        >
            <Typography gutterBottom={true}>Oops, an error occurred. Please check your payment method and be sure all required fields are filled in.</Typography>

            {errorMessage && (
                <Typography gutterBottom={true}>{errorMessage}</Typography>
            )}
            <Box my={2}>
                <Button onClick={handleClose} variant="contained" color="secondary">Close</Button>
            </Box>
        </Modal>
    );
}

export default connect(
    () => ({}),
    {
        setModalReset
    }
)(PaymentMethodErrorModal);